<template>
  <div class="regional">
    <regional-grid />
  </div>
</template>

<script>
import RegionalGrid from '@/domain/components/generalPanel/adminPanel/regional/List';
import GlobalUserService from '@/services/user';

export default {
  components: { RegionalGrid },
  created() {
    GlobalUserService.validateUserPermission('PER009');
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.regional
  &__header
    display: flex
    flex-direction: column
    padding: 10px
    button
      margin-top: 1em
  &__search-input
    width: 350px
  +media-min-sm()
    &__header
      flex-direction: row
      justify-content: space-between
      button
        margin-top: 0
        margin-left: 1em
</style>
